export const environment = {
  firebase: {
    projectId: 'runeterra-fc309',
    appId: '1:217036281106:web:5ce4a99d948f52001a8fcb',
    databaseURL: 'https://runeterra-fc309-default-rtdb.firebaseio.com',
    storageBucket: 'runeterra-fc309.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyAAVxAA4jkXm0uRs67dDizfbVrpojVtNd0',
    authDomain: 'accounts.runeterra.ar',
    messagingSenderId: '217036281106',
    measurementId: 'G-L5HZ4QP7XK',
    serviceAccountId: "firebase-adminsdk-3ta7s@runeterra-fc309.iam.gserviceaccount.com"
  },
  production: true
};
